import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';

import { DropdownSelectField, InputNumberField } from '@jutro/legacy/components';
import styles from './ServiceComponent.module.scss';
import metadata from './ServiceComponent.metadata.json5';
import messages from './ServiceComponent.messages';

function ServiceComponent(props) {

    const {
        data: ServiceVM,
        updateWizardData,
        submissionVM,
        ServicePath
    } = props;

    let { isSubContractService } = props;

    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);

    submissionVM.lobData.proLine.coverables.accountantCoverable.revenue.otherSubConsExists.value = isSubContractService &&
            !_.isUndefined(_.find(submissionVM.lobData.proLine.coverables.accountantCoverable.revenue.value.subContractedServices, (subContractedService) => subContractedService.proSer1 === 'Oth'))

    submissionVM.lobData.proLine.coverables.accountantCoverable.revenue.isOtherInService.value = !isSubContractService &&
            !_.isUndefined(_.find(submissionVM.lobData.proLine.coverables.accountantCoverable.revenue.value.services, (service) => service.proSer1 === 'Oth'))

    if(isSubContractService === undefined) {
        isSubContractService = false
    }


    const addService = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            ServiceVM.value = ServiceVM.value || []

            const { _xCenter, _dtoName } = ServiceVM;

            const ServiceObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            ServiceVM.pushElement(
                ServiceObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, ServiceVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            submissionVM.lobData.proLine.coverables.accountantCoverable.revenue.otherSubConsExists.value = 
            !_.isUndefined(_.find(submissionVM.lobData.proLine.coverables.accountantCoverable.revenue.value.subContractedServices, (subContractedService) => subContractedService.proSer1 === 'Oth'))
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            ServiceVM.value.splice(index, 1);
            _.set(submissionVM.value, ServicePath, ServiceVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, ServicePath, ServiceVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'proSer1') {
                const value = (item && item.proSer1) ? item.proSer1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = ServiceVM.length > 0 && ServiceVM.children[index].proSer1
                    // eslint-disable-next-line security/detect-object-injection
                    ? ServiceVM.children[index].proSer1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            // eslint-disable-next-line no-param-reassign
                            item.proSer1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                )
            }

            if (path === 'revCalByPer2') {
                const value = item.revCalByPer2 ? item.revCalByPer2 : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            // eslint-disable-next-line no-param-reassign
                            item.revCalByPer2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [ServiceVM.children, ServiceVM.length, handleValueChange, translator])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        ServiceTable: {
            data: ServiceVM.value,
        },
        pleAddTheSerThaApp1TypeHeader: {
            visible: !isSubContractService
        },
        revCalByPer3TypeHeader: {
            header: isSubContractService ? translator(messages.subContPercen) : translator(messages.revCalByPer3)
        }

    }), [ServiceVM.value, isSubContractService, translator])

    const resolvers = {
        resolveCallbackMap: {
            addService,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            ServiceVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [ServiceVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={ServiceVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ServiceComponent.propTypes = wizardProps;
export default withRouter(ServiceComponent);
